import { useStateMachine } from 'little-state-machine';
import React, { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form';
import { Button, Container } from '@chakra-ui/react';
import {
  Box,
  Stack,
} from "@chakra-ui/react"
import { navigate } from 'gatsby';

import updateAction from '../../helpers/updateAction'
import Banner from './Banner';
import NeedsMatrix from './NeedsMatrix';
import Details from './Details';
import useSlug from '../Layout/useSlug';
import { responsive } from '../../contexts/responsive';
import NavHeading from '../NavHeading'

export { query } from '../portalQuery'

const ContactPage = (data) => {
  const slug = useSlug()
  const { actions, state } = useStateMachine({ updateAction });
  const {
    handleSubmit,
    register,
    watch,
    control,
    formState: { errors },
  } = useForm({ defaultValues: state?.contact });
  const onSubmit = formData => {
    actions.updateAction({ contact: formData });
    navigate(`/${slug}/contact/detail`)
  };
  // const values = watch()
  // console.log(values)

  return (
    <Container py={responsive(4, 8)} minHeight="100%" as={Stack}>
      <Stack
        width="full"
        alignItems="stretch"
        bg="white"
        p="2"
        flex="1"
        borderRadius="sm"
        boxShadow="sm"
      >
        <NavHeading data={data} />
        <Stack as="form" flex="1" onSubmit={handleSubmit(onSubmit)}>
          <Banner {...data.contact} />
          <NeedsMatrix
            {...data.contact}
            control={control}
          />
          {data.contact?.template !== 'none' && (
            <>
              <Details register={register} watch={watch} errors={errors} />
              <Box flex="1" />
              <Box p="2">
                <Button colorScheme="primary" isFullWidth type="submit">下一步</Button>
              </Box>
            </>
          )}
        </Stack>
      </Stack>
    </Container>
  )
}

export default ContactPage
